module.exports = __webpack_public_path__ + "static/media/엽서 (8).202f8588.pdf";